export default __webpack_public_path__ + "70cce1a9836322b6dc248c1d39018067.jpg";